"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortValuesByOrder = sortValuesByOrder;
exports.sortKeysByOrder = sortKeysByOrder;

function sortValuesByOrder(obj) {
  return Object.values(obj).sort(function (item, nextItem) {
    return item.order - nextItem.order;
  });
}

function sortKeysByOrder(obj) {
  return Object.keys(obj).sort(function (itemKey, nextItemKey) {
    return obj[itemKey].order - obj[nextItemKey].order;
  });
}